<app-alert *ngIf="helperService.showAlert" [type]=helperService.typeAlert [Message]=helperService.messageAlert></app-alert>
<div class="container-fluid content-container">

  <div class="content-container">
    <app-carousel
      *ngIf="helperService.user.role.roleId === 4"
      [recievedArray]="brands"
      (brand)="setClickedBrand($event)"
    ></app-carousel>

    <mat-card>
      <mat-card class="hours-config-section">
        <mat-card-content *ngIf="helperService.user.role.roleId === 4">
          <div class="header-containerw">

            <div class="header-controlsw">
              <button
                mat-button
                *ngFor="let control of controls"
                (click)="onEditInformationClick()"
              >
                <i [ngClass]="control.icon"
                  >&nbsp; &nbsp;{{ "NewWorkshop" | translate }}</i
                >
              </button>
            </div>
          </div>
        </mat-card-content>

        <mat-card
          class="Workshop-grid-container"
          *ngIf="helperService.user.role.roleId === 4"
        >
          <ng-template class="loading-containerWorkshop" #loading>
            <div class="loading-containerWorkshop">
              <section>
                <div  class="pulsing">
                  <mat-spinner [diameter]="50" ></mat-spinner>
                </div>
                <p class="pulsing">{{"Loading" | translate}}</p>
              </section>
            </div>
          </ng-template>
          <div
            class="row"
            *ngIf="
              editionRequiredInformation$ | async as workshops;
              else loading
            "
          >
            <div class="col">
              <table class="table table-striped" style="width: 100%">
                <thead>
                  <tr class="Workshop-grid-headers">
                    <th scope="col">{{ "WorkshopName" | translate }}</th>
                    <th scope="col">{{ "State" | translate }}</th>
                    <th scope="col">{{ "City" | translate }}</th>
                    <th scope="col">{{ "Address" | translate }}</th>
                    <th scope="col">{{ "Phone" | translate }}</th>
                    <th scope="col">{{ "chiefOfWorkshop" | translate }}</th>
                    <th scope="col">{{ "Actions" | translate }}</th>
                  </tr>

                  <tr class="Workshop-grid-inputs">
                    <th scope="col">
                      <div class="col-lg-12">
                        <mat-form-field>
                          <mat-label>{{ "Filter" | translate }}</mat-label>
                          <input
                            matInput
                            type="text"
                            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                            [(ngModel)]="filterByWorkshopName"
                          />
                        </mat-form-field>
                      </div>
                    </th>
                    <th scope="col"></th>

                    <th scope="col">
                      <div class="col-lg-12">
                        <mat-form-field>
                          <mat-label>{{ "Filter" | translate }}</mat-label>
                          <input
                            matInput
                            type="text"
                            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                            [(ngModel)]="filterByCity"
                          />
                        </mat-form-field>
                      </div>
                    </th>
                    <th scope="col">
                      <div class="col-lg-12">
                        <mat-form-field>
                          <mat-label>{{ "Filter" | translate }}</mat-label>
                          <input
                            matInput
                            type="text"
                            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                            [(ngModel)]="filterByAddress"
                          />
                        </mat-form-field>
                      </div>
                    </th>
                    <th scope="col"></th>

                    <th scope="col">
                      <div class="col-lg-12">
                        <mat-form-field>
                          <mat-label>{{ "Filter" | translate }}</mat-label>
                          <input
                            matInput
                            type="text"
                            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                            [(ngModel)]="filterByChiefOfWorkshop"
                          />
                        </mat-form-field>
                      </div>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    *ngFor="
                      let workshop of workshops[0]
                        | filterWorkshops
                          : filterByWorkshopName
                          : filterByCity
                          : filterByAddress
                          : filterByChiefOfWorkshop
                          : brandNameFilter
                        | slice : desde : hasta;
                      let index = index
                    "
                  >
                    <td style="width: 13%; font-size: 16px; text-align: center">
                      {{ workshop.workshopName }}
                    </td>
                    <td style="width: 15%; font-size: 16px; text-align: center">
                      <mat-slide-toggle
                      *ngIf="workshop.isActive"

                      [(ngModel)]="workshop.isActive"
                      (toggleChange)="ChangeState(workshop)"

                    >
                      {{"Active" | translate | capitalize}}
                    </mat-slide-toggle>
                    <mat-slide-toggle
                    *ngIf="!workshop.isActive"


                    [(ngModel)]="workshop.isActive"
                    (toggleChange)="ChangeState(workshop)"

                  >
                    {{"Inactive" | translate | capitalize}}
                  </mat-slide-toggle>

                    </td>

                    <td style="width: 13%; font-size: 16px; text-align: center">
                      {{ workshop.cityName }}
                    </td>
                    <td style="width: 13%; font-size: 16px; text-align: center">
                      {{ workshop.address }}
                    </td>
                    <td style="width: 14%; font-size: 16px; text-align: center">
                      {{ workshop.phoneNumber }}
                    </td>
                    <td style="width: 14%; font-size: 16px; text-align: center">
                      {{ workshop.chiefOfWorkshop }}
                    </td>
                    <td style="width: 16%">
                      <div class="grid-controls">
                        <button class="action-btn">
                          <i
                            class="material-icons-outlined"
                            [id]="'pencil-' + index"
                            (click)="onEditInformationClick(workshop)"
                            matTooltip="{{ 'EditInformation' | translate }}"
                          >edit
                          </i>
                        </button>

                        <button class="action-btn">

                          <i
                            class="material-icons-outlined"
                            [id]="'clock-' + index"
                            style="color: #fff"
                            (click)="onConfigureHoursClick(workshop)"
                            matTooltip="{{ 'SetAvailableDays' | translate }} "
                          >access_time
                          </i>
                        </button>

                        <button class="action-btn">

                          <i
                            class="material-icons-outlined"
                            style="color: #fff"
                            [id]="'calendar-x-' + index"
                            (click)="onLockSettingsClick(workshop)"
                            matTooltip="{{ 'ConfigureBlock' | translate }}"
                          >free_cancellation
                          </i>
                        </button>

                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row Workshop-grid-footer">
              <mat-divider></mat-divider>
            </div>
            <div class="row grid-pagination-container">
              <mat-paginator
                [length]="
                  (
                    workshops[0]
                    | filterWorkshops
                      : filterByWorkshopName
                      : filterByCity
                      : filterByAddress
                      : filterByChiefOfWorkshop
                      : brandNameFilter
                  )?.length
                "
                [pageSize]="pagesize"
                [pageSizeOptions]="[4, 8, 16, 32]"
                aria-label="Select page"
                (page)="changePage($event)"
                showFirstLastButtons
              >
              </mat-paginator>
            </div>
          </div>
        </mat-card>

        <!-- Grilla workshopContainer -->
        <mat-card
          class="workshop-grid-container"
          *ngIf="helperService.user.role.roleId === 2"
        >
          <ng-template class="loading-containerWorkshop" #loading>
            <div class="loading-containerAdvisor">
              <section>
                <div  class="pulsing">
                  <mat-spinner [diameter]="50" ></mat-spinner>
                </div>
                <p class="pulsing">{{"Loading" | translate}}</p>
              </section>
            </div>
          </ng-template>
          <div
            *ngIf="
              editionRequiredInformation$ | async as workshops;
              else loading
            "
            class="retail-grid-container"
          >
            <div
              *ngFor="
                let workshop of workshops[0]
                  | filterWorkshops
                    : filterByWorkshopName
                    : filterByCity
                    : filterByAddress
                    : filterByChiefOfWorkshop
                    : brandNameFilter
                  | slice : desde : hasta;
                let index = index
              "
            >
              <mat-card
                class="workshop-grid-container hours-config-section-workshop row"
                class="data-container workshop-grid-headers-ad"
              >
                <div class="data-row">
                  <div>
                    <h2>
                      {{ "WorkshopName" | translate }}
                    </h2>
                    <p>
                      {{ workshop.workshopName }}
                    </p>
                  </div>

                  <div>
                    <h2>
                      {{ "State" | translate }}
                    </h2>
                    <mat-slide-toggle
                    *ngIf="workshop.isActive"

                    [(ngModel)]="workshop.isActive"
                    (toggleChange)="ChangeState(workshop)"

                  >
                    {{"Active" | translate | capitalize}}
                  </mat-slide-toggle>
                  <mat-slide-toggle
                  *ngIf="!workshop.isActive"


                  [(ngModel)]="workshop.isActive"
                  (toggleChange)="ChangeState(workshop)"

                >
                  {{"Inactive" | translate | capitalize}}
                </mat-slide-toggle>
                  </div>
                  <div>
                    <h2>
                      {{ "Address" | translate }}
                    </h2>
                    <p>
                      {{ workshop.address }}
                    </p>
                  </div>

                  <div>
                    <h2>
                      {{ "Phone" | translate }}
                    </h2>
                    <p>
                      {{ workshop.phoneNumber }}
                    </p>
                  </div>
                  <div>
                    <h2>
                      {{ "TypesOfService" | translate }}
                    </h2>
                    <div>
                      <p
                        *ngFor="
                          let services of workshop.services;
                          let i = index
                        "
                      >
                        {{ services.serviceName | translate }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="container-controls">
                  <button
                    class="configure-hour"
                    (click)="onLockSettingsClick(workshop)"
                  >

                  <i
                  class="material-icons-outlined"
                    [id]="'calendar-x-' + index"
                    matTooltip="{{ 'ConfigureBlock' | translate }}"
                  >free_cancellation
                  </i>

                    <p>{{ "ConfigureBlock" | translate }}</p>
                  </button>
                </div>
              </mat-card>
            </div>
          </div>
        </mat-card>
      </mat-card>
    </mat-card>
  </div>
</div>
